<!--The content below is only a placeholder and can be replaced.-->
<!--<div style="text-align:center">
  <h1>
    Welcome to {{ title }}!
  </h1>
</div>-->
<!-- <div  class="app-outlet" [@appAnimation]="getAnimationData(routerOutlet)"> -->
  <div class="container" #resizable> 
    <router-outlet ></router-outlet>
  </div>
  <!-- <router-outlet #routerOutlet="outlet"></router-outlet> -->
  <!-- </div> -->